import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import data from "../../json/Agiletesting/Agiletesting2.json";

const Agilitesting2 = () => {
  const { testing } = useParams();
  const [top, setTop] = useState("0px");
  const [bottom, setBottom] = useState("0px");
  const pRef = useRef(null);

  useEffect(() => {
    const updateTop = () => {
      if (pRef.current) {
        const pWidth = pRef.current.offsetHeight;
        const calculatedTop = -(pWidth / 2) + "px"; // Example calculation
        const getbottom = pWidth / 2 + "px";
        setTop(calculatedTop);
        setBottom(getbottom);
      }
    };

    // Update top on component mount and when window resizes
    updateTop();
    window.addEventListener("resize", updateTop);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener("resize", updateTop);
  }, []);

  return (
    <div className="2xl:container flex justify-center p-4 md:p-0 md:px:20 flex-col items-center w-full">
      {testing !== "webdevelopmenttesting" ? (
        <p
          ref={pRef}
          className="text-16 md:text-24 p-4 md:p-12 mx-auto md:w-9/12 bg-year text-white text-center z-10"
        >
          {data[testing].para1}
        </p>
      ) : (
        <div
          ref={pRef}
          className="bg-year text-white p-4 md:p-12 md:w-9/12 font-medium text-center flex flex-col gap-3 z-10"
        >
          <p className="text-12 md:text-[16px]">{data[testing].para1}</p>
          <p className="text-18 md:text-32">{data[testing].para2}</p>
          <p className="text-12 md:text-[16px]">{data[testing].para3}</p>
        </div>
      )}
      <div
        style={{ marginTop: top, paddingTop: bottom }}
        className="bg-o md:bg-gray"
      >
        <div className="grid md:grid-cols-3 gap-[25px] md:mx-20 my-8 md:my-[56px] bg-white p-4 md:p-10">
          {data[testing].section.map((item, id) => (
            <div key={id}>
              <p className="text-18 md:text-20 font-medium text-highlight mb-1 md:mb-2">
                {item.title}
              </p>
              {item.para.map((items, index) => (
                <div className="flex gap-3 text-14 md:text-18 text-secondaryblack mt-4 md:mt-6 items-start">
                  <img
                    src={
                      process.env.PUBLIC_URL + "/images/Agiletesting/dot.svg"
                    }
                    alt="dot"
                    className="pt-1 md:pt-2"
                  />
                  <p className="">{items}</p>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Agilitesting2;
